export default { sha: '3729980a29ba5bfa52a5a90432ab5320cebfed81', buildNumber: 'undefined' }
